<template>
  <div>
    <NewAberrationRuhContainer
      icon="mdi-alert-octagram-outline"
      aberrationCategory="2"
      categoryName="HMS Hendelse"
      @save="save"
    />
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import notification from "@/helpers/notification";
import aberrationApi from "@/api/aberrationApi";

import NewAberrationRuhContainer from "@/components/aberration/new/children/NewAberrationRuhContainer.vue";

export default Vue.extend({
  methods: {
    save(aberration) {
      aberrationApi.ruhInsertupdate(aberration).then(() => {
        notification.success("HMS-H lagt til!");
        this.$router.go(-1);
      });
    },
  },
  components: {
    NewAberrationRuhContainer,
  },
});
</script>
